var $ = require("./..\\..\\..\\bower_components\\jquery\\dist\\jquery.js");

module.exports = function(flag) {
  $('.card .front').css('background-image', 'url("images/flags/' + flag + '.png")');
};
